import React from "react"
import * as PropTypes from "prop-types"

import id from "@irati/utils/id"
import {FormattedMessage} from "@irati/utils/lang"
import {RouterLink} from "@irati/ui/src/Link"
import tracking from "@irati-tracking/perks/perks"

import {OptionIcon} from "../../styled"

const DealsMenuLink = (props, {apps}) => {
  return (
    <RouterLink
      id={id("link-my-perks", props)}
      onClick={tracking.viewMyPerks}
      to="/account/my-perks/new"
      plain
      app={apps.PERKS}>
      <OptionIcon icon="myPerks" />
      <FormattedMessage id="platform.userMenuContext.deals.href.text" />
    </RouterLink>
  )
}

DealsMenuLink.contextTypes = {
  apps: PropTypes.object.isRequired
}

export default DealsMenuLink
